import React, { useRef, useState } from 'react';
import {
  InputContainer,
  InputStyled,
  Label,
  MainContainer,
  TypeOption,
  TypeSelector,
  InputError,
  TypeSelectorOpContainer,
  Img
} from './styles';
import Check from '../../../../../assets/icons/check.svg';
import Chevron from '../../../../../assets/icons/chevron.svg';
import ChevronDisabled from '../../../../../assets/icons/chevron-disabled.svg';
import { useOutsideClick } from '@panel/commons';
import { getCurrencySymbolByCode } from '@panel/commons/helpers/currenciesBySite';

const PriceSelector = ({
  name = '',
  placeholder = '',
  type = 'text',
  typesOptions = [],
  register = () => {},
  label = '',
  width = '0px',
  typeSelectorPosition = 'right',
  error = null,
  onSelect = () => {},
  currentValue,
  disabled = false,
  hasOptions = true,
  priceValue = 0,
  onInputChange = () => {},
  isSecondPrice = false,
  dataPubli = '',
  maxLength = 13
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const positionRef = useRef();

  const handleOnClick = value => {
    onSelect(value);
    setIsOpen(false);
  };

  useOutsideClick(positionRef, () => {
    if (isOpen) {
      setIsOpen(false);
    }
  });

  return (
    <MainContainer isSecondPrice={isSecondPrice} width={width} data-publi={`${dataPubli}-container`}>
      <Label data-publi={`${dataPubli}-label`}>{label}</Label>
      <InputContainer typeSelectorPosition={typeSelectorPosition} error={error} disabled={disabled} isOpen={isOpen}>
        <TypeSelector
          typeSelectorPosition={typeSelectorPosition}
          error={error}
          disabled={disabled}
          hasOptions={hasOptions}
          isOpen={isOpen}
          tabIndex={disabled || !hasOptions ? -1 : 0}
          onClick={e => {
            e.stopPropagation();
            if (!disabled && hasOptions) {
              setIsOpen(!isOpen);
            }
          }}
          onKeyDown={e => {
            if (disabled || !hasOptions) return;
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setIsOpen(prev => !prev);
            }
          }}
          data-publi={`${dataPubli}-typeSelector`}
        >
          {getCurrencySymbolByCode(currentValue)}
          {hasOptions && (
            <Img src={disabled ? ChevronDisabled : Chevron} alt='chevron' isOpen={isOpen} height={'16px'} />
          )}
        </TypeSelector>
        {isOpen && (
          <TypeSelectorOpContainer ref={positionRef} data-publi={`${dataPubli}-typeSelectorOpContainer`}>
            {typesOptions?.map(option => {
              return (
                <TypeOption
                  name={name + 'Select'}
                  key={option.value}
                  onClick={() => handleOnClick(option.value)}
                  value={option.value}
                  isSelected={currentValue === option.value}
                  data-publi={`${dataPubli}-op-${option.value}`}
                >
                  {getCurrencySymbolByCode(option.value)}
                  {currentValue === option.value && <Img src={Check} alt='checked' />}
                </TypeOption>
              );
            })}
          </TypeSelectorOpContainer>
        )}
        <InputStyled
          placeholder={placeholder}
          type={type}
          name={name}
          ref={register}
          disabled={disabled}
          value={priceValue}
          autoComplete='off'
          onChange={e => {
            const value = e.target.value;
            const lastCharInserted = value[value.length - 1];
            const isNumeric = /^[0-9]$/.test(lastCharInserted);
            if (isNumeric && value.length < maxLength) {
              onInputChange(value);
            } else {
              onInputChange(value.slice(0, -1));
            }
          }}
          data-publi={`${dataPubli}-input`}
        />
      </InputContainer>
      {error && <InputError data-publi={`${dataPubli}-error`}>{error}</InputError>}
    </MainContainer>
  );
};

export default PriceSelector;
